<form *ngIf="form" [formGroup]="form" class="form-b4a" (submit)="submit()">
  <p-fieldset legend="Informações básicas">
    <span class="p-float-label">
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('name') }"
        (input)="slugify()"
        (blur)="slugify()"
      />
      <label for="name">Nome do produto *</label>
      <small class="error" *ngIf="invalidControl('name')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <input
        id="slug"
        type="text"
        pInputText
        formControlName="slug"
        readonly
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('slug') }"
      />
      <label for="slug">Slug *</label>
      <small class="error" *ngIf="invalidControl('slug')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="gender"
        inputId="gender"
        [options]="genders"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [autoDisplayFirst]="false"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('gender') }"
      />
      <label for="gender">Gênero *</label>
      <small class="error" *ngIf="invalidControl('gender')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="brand"
        inputId="brand"
        [options]="brands"
        optionValue="name"
        optionLabel="name"
        appendTo="body"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('brand') }"
      />
      <label for="brand">Marca *</label>
      <small class="error" *ngIf="invalidControl('brand')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <input
        id="weight"
        type="number"
        pInputText
        formControlName="weight"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('weight') }"
      />
      <label for="weight">Peso *</label>
      <small class="error" *ngIf="invalidControl('weight')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <p-inputMask id="daysOfUse" formControlName="daysOfUse" mask="9?999">
      </p-inputMask>
      <label for="daysOfUse">Dias de uso</label>
    </span>
    <span class="p-float-label">
      <p-dropdown
        inputId="category"
        [options]="groupedCategories"
        formControlName="category"
        placeholder="Selecione uma categoria"
        [group]="true"
        class="w-full md:w-56"
        (onChange)="findCategoryTree(form.value.category?.id)"
        [filter]="true"
        filterBy="label"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('category') }"
      >
        <ng-template let-group #group>
          <span>{{ group.label }}</span>
        </ng-template>
      </p-dropdown>
      <label for="category">Categoria *</label>
      <small class="error" *ngIf="invalidControl('category')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <input type="text" pInputText formControlName="categoryTree" />
      <label for="categoryTree">Árvore de categoria</label>
    </span>
    <span class="p-float-label">
      <input
        id="type"
        type="text"
        pInputText
        formControlName="type"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('type') }"
      />
      <label for="type">Tipo do produto *</label>
      <small class="error" *ngIf="invalidControl('type')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="label"
        inputId="label"
        [options]="labels"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [autoDisplayFirst]="true"
      />
      <label for="label">Label</label>
    </span>
    <ng-container *ngIf="!product?.hasVariants">
      <span class="p-float-label">
        <p-dropdown
          formControlName="groupId"
          inputId="groupId"
          [options]="groups"
          optionValue="value"
          optionLabel="name"
          appendTo="body"
          [autoDisplayFirst]="false"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('groupId') }"
        />
        <label for="groupId">Grupo *</label>
        <small class="error" *ngIf="invalidControl('groupId')">Obrigatório</small>
      </span>
      <span class="p-float-label">
        <p-dropdown
          formControlName="validity"
          inputId="validity"
          [options]="validities"
          optionValue="value"
          optionLabel="name"
          appendTo="body"
          [autoDisplayFirst]="true"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('validity') }"
        />
        <label for="validity">Vigente *</label>
        <small class="error" *ngIf="invalidControl('validity')">Obrigatório</small>
      </span>
    </ng-container>
    <ng-container *ngIf="product?.hasVariants">
      <span class="p-float-label">
        <p-dropdown
          formControlName="showVariants"
          inputId="showVariants"
          [options]="showVariantsOptions"
          optionValue="value"
          optionLabel="name"
          appendTo="body"
          [autoDisplayFirst]="true"
        />
        <label for="group">Modo exibição</label>
      </span>
    </ng-container>
    <span class="p-input-checkbox">
      <p-checkbox
        formControlName="published"
        [binary]="true"
        inputId="published"
        (onChange)="onPublishedChange($event)"
      ></p-checkbox>
      <label for="published">Publicado?</label>
    </span>
  </p-fieldset>
  <p-fieldset legend="Preço" formGroupName="price">
    <span class="p-float-label">
      <p-inputNumber
        id="fullPrice"
        formControlName="fullPrice"
        prefix="R$"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [min]="0.01"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('price.fullPrice') }"
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
      />
      <label for="fullPrice">Preço cheio *</label>
      <small class="error" *ngIf="invalidControl('price.fullPrice')"
        >Obrigatório</small
      >
    </span>
    <span class="p-float-label">
      <p-inputNumber
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
        id="price"
        formControlName="price"
        prefix="R$"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [min]="0.01"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('price.price') }"
      />
      <label for="price">Preço *</label>
      <small class="error" *ngIf="invalidControl('price.price')"
        >Obrigatório</small
      >
    </span>
    <span class="p-float-label">
      <p-inputNumber
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
        id="subscriberDiscount"
        type="number"
        suffix="%"
        formControlName="subscriberDiscountPercentage"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl(
            'price.subscriberDiscountPercentage'
          )
        }"
      />
      <label for="subscriberDiscount">Desconto de assinante *</label>
      <small
        class="error"
        *ngIf="invalidControl('price.subscriberDiscountPercentage')"
        >Obrigatório</small
      >
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="subscriberPrice"
        prefix="R$"
        formControlName="subscriberPrice"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
      />
      <label for="subscriberPrice">Preço de assinate *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="fullPriceDiscountPercentage"
        formControlName="fullPriceDiscountPercentage"
        suffix="%"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
      />
      <label for="fullPriceDiscountPercentage">Desconto preço cheio *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="costPrice"
        formControlName="costPrice"
        prefix="R$"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
      />
      <label for="fullPriceDiscountPercentage">Preço de custo</label>
    </span>
  </p-fieldset>

  <p-fieldset legend="Fiscal">
    <span class="p-float-label">
      <input
        id="EAN"
        type="text"
        pInputText
        formControlName="EAN"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('EAN') }"
      />
      <label for="EAN">EAN/GTIN *</label>
      <small class="error" *ngIf="invalidControl('EAN')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <input
        id="NCM"
        type="text"
        pInputText
        formControlName="NCM"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('NCM') }"
      />
      <label for="NCM">NCM *</label>
      <small class="error" *ngIf="invalidControl('NCM')">Obrigatório</small>
    </span>
    <span class="p-float-label">
      <input id="CEST" type="text" pInputText formControlName="CEST" />
      <label for="CEST">CEST</label>
    </span>
  </p-fieldset>

  <p-fieldset legend="Curadoria">
    <span class="p-float-label">
      <p-inputNumber
        id="caixariaMinima"
        formControlName="caixariaMinima"
        [useGrouping]="false"
        [min]="0"
        [maxFractionDigits]="0"
        [minFractionDigits]="0"
      />
      <label for="caixariaMinima">Caixaria mínima</label>
    </span>
    <span class="p-float-label">
      <p-multiSelect
        formControlName="suppliers"
        inputId="suppliers"
        [options]="suppliersOptions"
        optionLabel="name"
        dataKey="clientId"
        appendTo="body"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        display="chip"
        placeholder="Selecione fornecedores"
      />
      <label for="suppliers">Fornecedor</label>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="curve"
        inputId="curve"
        [options]="curveOptions"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [showClear]="true"
        [autoDisplayFirst]="false"
      />
      <label for="curve">Curva</label>
    </span>
    <span class="p-float-label">
      <input
        id="validade"
        type="text"
        pInputText
        formControlName="validade"
        readonly
      />
      <label for="validade">Validade (Millenium)</label>
    </span>
    <span class="p-float-label">
      <input
        id="estoqueLote"
        type="text"
        pInputText
        formControlName="estoqueLote"
        readonly
      />
      <label for="estoqueLote">Estoque do lote (validade)</label>
    </span>
  </p-fieldset>

  <p-fieldset legend="Metadata" formGroupName="metadata">
    <span class="p-float-label">
      <input
        id="title"
        type="text"
        pInputText
        formControlName="title"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('metadata.title') }"
      />
      <label for="title">Título *</label>
      <small class="error" *ngIf="invalidControl('metadata.title')"
        >Obrigatório</small
      >
    </span>
    <span class="p-float-label">
      <input
        id="description"
        type="text"
        pInputText
        formControlName="description"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('metadata.description')
        }"
      />
      <label for="description">Descrição *</label>
      <small class="error" *ngIf="invalidControl('metadata.description')"
        >Obrigatório</small
      >
    </span>
  </p-fieldset>

  <p-fieldset legend="Tags">
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsCollection"
        [separator]="chipRegex"
        inputId="tagsCollection"
        name="tagsCollection"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addCollectionTag($event)"
        (onBlur)="addCollectionTag($event)"
        (onClear)="form.controls['tagsCollection'].setValue([])"
      />
      <label for="tagsCollection">Tags de collection</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsProfile"
        [separator]="chipRegex"
        inputId="tagsProfile"
        name="tagsProfile"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addProfileTag($event)"
        (onBlur)="addProfileTag($event)"
        (onClear)="form.controls['tagsProfile'].setValue([])"
      />
      <label for="tagsProfile">Tags de perfil</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsSupply"
        [separator]="chipRegex"
        inputId="tagsSupply"
        name="tagsSupply"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addSupplyTag($event)"
        (onBlur)="addSupplyTag($event)"
        (onClear)="form.controls['tagsSupply'].setValue([])"
      />
      <label for="tagsSupply">Tags de supply</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label">
      <p-autoComplete
        [suggestions]="filterOptionsAvailable"
        formControlName="filters"
        filterBy="description"
        optionLabel="id"
        appendTo="body"
        [lazy]="false"
        [multiple]="true"
        (completeMethod)="searchFilters($event)"
        [showClear]="true"
        (onClear)="categoryForm.controls['filters'].setValue([])"
      />
      <label for="filters">Fitros</label>
    </span>
  </p-fieldset>

  <div class="form-footer">
    <div class="info">
      <div *ngIf="product">
        <p>*Última alteração em: {{ product.updatedAt | date: 'short' }}</p>
      </div>
    </div>
    <div class="action">
      <p-button
        *ngIf="permission"
        type="submit"
        pRipple
        label="Salvar"
        severity="primary"
      >
      </p-button>
    </div>
  </div>
</form>
<p-toast />
